import editTheme from './editTheme';

export default editTheme;
